export default __webpack_public_path__ + "images/VR.cd80a9c.png";